import React, { useState, useEffect } from "react";
import { Modal, Button, Tabs, Tab, Form } from "react-bootstrap";
import Loading from "@/app/core/layouts/main/components/Loading";
import Storage from "@/app/core/util/Storage";
import { ToastContainer, toast } from "react-toastify";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import CompanySearch from "@/app/core/layouts/main-components/input/CompanySearch";
import Field from "@/app/core/layouts/main-components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import UploadButton from "@/app/core/layouts/main-components/input/UploadButton";
import { FileController } from "@/app/core/base/controllers/FileController";
import RegisterOrLoginModal from "@/app/core/layouts/main-components/account/RegisterOrLoginModal";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { GeneralHelper } from "@/app/core/util/helpers/GeneralHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { EmailController } from "@/app/core/base/controllers/EmailController";
import { PagarMeController } from "@/app/core/base/controllers/PagarMeController";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";
import Functions from "@/app/core/util/Functions";
import {
  GetAddress,
  States,
} from "@/app/core/base/controllers/AddressController";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { ServiceHelper } from "@/app/core/util/helpers/ServiceHelper";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";

export default function MainDashboard(props) {
  const date = new Date();
  const enviroment = process.env.REACT_APP_ENV;

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [data, setData] = useState({ images: [], oldId: 0, status: ComplainHelper.Status.Pending });
  const [company, setCompany] = useState({});
  const [change, setChange] = useState(date.getTime());
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [cardData, setCardData] = useState({
    data: {
      number: "",
      holderName: "",
      expMonth: "",
      expYear: "",
      cvv: "",
      billingAddress: {
        street: "",
        number: "",
        neighborhood: "",
        zipCode: "",
        city: "",
        state: "",
        country: "",
      },
    },
  });

  const [pixData, setPixData] = useState({
    qrCode: "",
    qrCodeUrl: "",
    expiresAt: "",
    hasError: false,
    errorMessage: "",
  });

  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const closePaymentModal = () => setShowPaymentModal(false);
  const openPaymentModal = () => setShowPaymentModal(true);

  useEffect(() => {
    loadServices();

    const complain = null; //Storage.getComplain();
    if (complain) {
      setData(complain);
      if (complain.companyId) {
        loadEmpresa(complain.companyId);
        setStep(2);
      } else {
        setStep(1);
      }
    } else {
      loadAutomations();
    }

    // If user is already authenticated, pre-initialize the form fields with user data
    // This includes userName, email, phone, document, neighborhood, and city
    // to provide a better user experience by auto-filling known information.
    const userData = Storage.getUserData();
    if (userData) {
      setData((prevData) => ({
        ...prevData,
        userName: userData.name,
        email: userData.email,
        phone: userData.phone?.replace(/[^\d]+/g, ""),
        document: userData.document?.replace(/[^\d]+/g, ""),
        neighborhood: userData.neighborhood,
        city: userData.city,
      }));
    }
  }, []);

  useEffect(() => {
    // Storage.setComplain(data);
    GeneralHelper.UpdateMetaTags(
      "Registrar reclamação",
      "Reclamar sobre um serviço ou produto de uma empresa"
    );
  }, [data]);

  async function loadServices() {
    const services = await ServicesController.List({ status: ServiceHelper.Status.Active });
    setServices(services);
  }

  async function loadAutomations() {
    const query = getUrlComponent("empresa") || "";
    const register = getUrlComponent("newCompany") || "";

    if (query != "") {
      loadEmpresa(query);
      setStep(2);
      setData({ ...data, companyId: query });
    } else if (register != "") {
      setCompany({ ...company, name: register, newRegistry: true });
    }
  }

  async function loadEmpresa(query) {
    console.log("Procurando a empreas", query);
    const res = await CompanyController.Get(query);
    console.log("Achou a empreas", res);
    setCompany(res);
  }

  function getUrlComponent(componentName) {
    if (!props) {
      return null;
    }
    const params = new URLSearchParams(props.location.search);
    return params.get(componentName);
  }

  const handleCopyPixCode = async (e) => {
    e.preventDefault();

    try {
      await navigator.clipboard.writeText(pixData.qrCode);
      toast.success("Chave Pix copiada para a área de transferência!");
    } catch (err) {
      toast.error("Falha ao copiar a chave Pix.");
    }
  };

  const handleCardDataChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("billingAddress.")) {
      if (
        name === "billingAddress.zipCode" &&
        typeof value === "string" &&
        value.replace("-", "").length === 8
      ) {
        GetAddress(value, (address) => {
          setCardData((prevState) => ({
            data: {
              ...prevState.data,
              billingAddress: {
                ...prevState.data.billingAddress,
                ...address,
                zipCode: value,
              },
            },
          }));
        });
      } else {
        const field = name.split(".")[1];
        setCardData((prevState) => ({
          data: {
            ...prevState.data,
            billingAddress: {
              ...prevState.data.billingAddress,
              [field]: value,
            },
          },
        }));
      }
    } else {
      setCardData((prevState) => ({
        data: {
          ...prevState.data,
          [name]: value,
        },
      }));
    }
  };

  const handleCardSubmit = async (e) => {
    e.preventDefault();

    // Validate card data
    const { number, holderName, expMonth, expYear, cvv, billingAddress } =
      cardData.data;

    if (
      !number ||
      !holderName ||
      !expMonth ||
      !expYear ||
      !cvv ||
      !billingAddress.zipCode
    ) {
      toast.error("Todos os campos são obrigatórios.");
      return;
    }

    await submitOrder("credit_card");
  };

  const handlePixSubmit = async (e) => {
    e.preventDefault();

    await submitOrder("pix");
  };

  const handleServiceSelection = (serviceId) => {
    setSelectedServices((prevSelected) =>
      prevSelected.includes(serviceId)
        ? prevSelected.filter((id) => id !== serviceId)
        : [...prevSelected, serviceId]
    );
  };

  async function submitOrder(paymentMethod) {
    const userData = Storage.getUserData();
    if (!userData) {
      toast.error(Message.NotLogged);
      return;
    }

    // Validate user data
    const phone = Functions.ExtractBrazilianPhone(userData.phone);
    const cardToken =
      paymentMethod === "credit_card"
        ? await PagarMeController.CreateCardToken(cardData.data)
        : undefined;

    const items = selectedServices.map((serviceId) => {
      const service = services.find((s) => s.id === serviceId);
      return {
        code: service.id,
        amount: Functions.ToPriceAmount(service.price),
        description: service.name,
        quantity: 1,
      };
    });

    setLoading(true);
    const orderResp = await PagarMeController.CreateOrder({
      closed: true,
      complainId: data.id,
      customer: {
        code: userData.id,
        name: userData.name,
        email: userData.email,
        document: data.document,
        documentType: Functions.GetDocumentType(userData.document),
        type: Functions.GetCustomerType(userData.document),
        phones: {
          mobilePhone: {
            countryCode: phone.countryCode,
            areaCode: phone.areaCode,
            number: phone.number,
          },
        },
      },
      items: items,
      payments: [
        {
          paymentMethod: paymentMethod,
          creditCard:
            paymentMethod === "credit_card"
              ? {
                  recurrence: false,
                  installments: 1,
                  statementDescriptor: "Reclame Rio",
                  cardToken: cardToken?.result?.id,
                  card: {
                    billingAddress: {
                      line1: [
                        cardData.data.billingAddress.number,
                        cardData.data.billingAddress.street,
                        cardData.data.billingAddress.neighborhood,
                      ]
                        .filter((part) => part)
                        .join(", "),
                      zipCode: cardData.data.billingAddress.zipCode,
                      city: cardData.data.billingAddress.city,
                      state: cardData.data.billingAddress.state,
                      country: cardData.data.billingAddress.country,
                    },
                  },
                }
              : undefined,
          // pix: paymentMethod === "pix" ? { expiresIn: 1800 } : undefined,
        },
      ],
    });
    setLoading(false);

    setData({
      ...data,
      orderId: orderResp.orderId,
      orderStatus: orderResp.status,
      selectedServices: [...selectedServices],
    });

    if (paymentMethod == "credit_card") {
      if (orderResp.status === "paid") {
        donePayment();
      } else {
        checkOrderPaymentStatus(orderResp.orderId);
      }
    }

    if (paymentMethod === "pix") {
      for (let charge of orderResp.charges) {
        if (charge.paymentMethod === paymentMethod) {
          const { qrCode, qrCodeUrl, expiresAt, gatewayResponse } =
            charge.lastTransaction;
          const errors = gatewayResponse?.errors || [];
          const errorMessage =
            errors.length > 0
              ? errors.map((error) => error.message).join(", ")
              : null;

          setPixData({
            qrCode,
            qrCodeUrl,
            expiresAt,
            hasError: !!errorMessage,
            errorMessage,
          });
          break;
        }
      }
    }
  }

  const handleOrderPaymentStatus = async (e) => {
    e.preventDefault();
    checkOrderPaymentStatus(data.orderId);
  };

  async function checkOrderPaymentStatus(orderId) {
    const orderResp = await PagarMeController.GetOrder(orderId);

    setData({
      ...data,
      orderId: orderResp.orderId,
      orderStatus: orderResp.status,
    });

    if (orderResp.status === "paid") {
      donePayment();
    }

    switch (orderResp.status) {
      case "pending":
        toast.info("Pagamento pendente.");
        break;
      case "paid":
        toast.success("Pagamento realizado com sucesso!");
        donePayment();
        break;
      case "canceled":
        toast.error("Pagamento cancelado.");
        break;
      case "failed":
        toast.error("Falha no pagamento.");
        break;
    }
  }

  function donePayment() {
    closePaymentModal();
    goToStep4();
  }

  async function validateFieldsForSubmission() {
    const requiredFields = {
      title: "título",
      description: "descrição",
      phone: "telefone",
      userName: "nome",
      email: "email",
      city: "cidade",
      neighborhood: "bairro",
    };

    for (const field in requiredFields) {
      if (!data[field] || data[field].trim() === "") {
        toast.error(`O campo ${requiredFields[field]} é obrigatório`);
        return;
      }
    }
    if (!data.document && selectedServices.length > 0) {
      toast.error(`O campo CPF é obrigatório`);
      return;
    }
    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(data.email)) {
      toast.error("E-mail inválido");
      return;
    }

    // Phone validation (only digits, min length)
    const phonePattern = /^[0-9]{10,15}$/;
    if (!phonePattern.test(data.phone)) {
      toast.error(
        "Telefone inválido. Deve conter apenas números e ter entre 10 e 15 dígitos."
      );
      return;
    }

    await validateUserForSubmission();
  }

  async function validateUserForSubmission() {
    if (Storage.getUserData() !== null) {
      await submitComplain();
      return;
    }

    // Não está logado, verificar se o usuário já existe
    const results = await AccountController.FindByEmail(data.email);
    if (results.length > 0) {
      Storage.setUserData(results[0]);
      toast.error(
        "Já existe um usuário com este endereço de email cadastrado. Por favor, faça login para continuar."
      );
      return;
    }

    // Criar o usuário e colocar seu telefone como a senha provisória
    let baseUser = { ...data };
    baseUser.name = baseUser.userName;
    baseUser.password = baseUser.phone;

    await AccountController.CreateUser(baseUser, false, async (close) => {
      EmailController.SendAccountPassword(baseUser);
      await submitComplain();
    });
  }

  async function submitComplain() {
    setTimeout(async () => {
      setShowModal(false);

      const user = Storage.getUserData();
      if (user == null) {
        toast.error(Message.NotLogged);
        return;
      }

      let dataCopy = {
        ...data,
        userId: user.uid,
        selectedServices: [...selectedServices],
      };

      if (!dataCopy.oldId) {
        dataCopy.oldId = (await ComplainController.GetTotalCount()) + 1;
      }

      const complainId = await (dataCopy.id
        ? ComplainController.Update(dataCopy)
        : ComplainController.Insert(dataCopy));

      setData({ ...dataCopy, id: complainId });
      goToStep3();
    }, 500);
  }

  function goToStep3() {
    toast.success(Message.Saved);
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setStep(3);
  }

  function goToStep4() {
    toast.success(Message.Saved);
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setStep(4);
    Storage.removeComplain();
  }

  function didntFind() {
    setCompany({ ...company, newRegistry: true });
  }

  function goToComplains() {
    window.location = "#/perfil";
  }

  function goHome() {
    window.location = "/";
  }

  function selectedCompany(id) {
    window.location = `#/reclamar/?empresa=${id}`;
    window.location.reload();
  }

  function handleChange(evt, type) {
    setData(OnDataChange(data, evt, type));
  }

  async function uploadFiles(files) {
    setLoading(true);

    try {
      const uploadedImages = await Promise.all(
        files.map(async (file, index) => {
          console.log("Uploading file:", file.name);

          const pathRef = `empresas/${data.companyId}/${file.name}`;
          const metadata = await FileController.UploadFile(pathRef, file);

          if (metadata) {
            return {
              url: metadata.url,
              name: metadata.name,
              contentType: metadata.contentType,
              fullPath: metadata.fullPath,
              bucket: metadata.bucket,
              position: data.images.length + index + 1,
              highlight: index === 0, // Highlight the first uploaded image
            };
          }

          return null;
        })
      );

      // Filter out any null values in case of errors
      const validUploadedImages = uploadedImages.filter(
        (image) => image && image !== null
      );

      // Update state with new images
      const updatedData = {
        ...data,
        images: [...(data.images || []), ...validUploadedImages],
      };

      setData(updatedData);
      console.log("Arquivos", updatedData);
    } catch (error) {
      // General error handling
      toast.error("Erro ao atualizar imagens. Tente novamente.");
      console.error("Error uploading images:", error);
    } finally {
      setLoading(false);
    }
  }

  function deleteImage(item, index) {
    if (window.confirm(Message.DeleteConfirm)) {
      let oldData = data;
      let newPhotos = [];
      for (let s in oldData.images) {
        if (s != index) {
          newPhotos.push(oldData.images[s]);
        }
      }
      oldData.images = newPhotos;
      console.log("Novas fotos", oldData);
      setData(oldData);
      Storage.setComplain(oldData);
      notifyChange();
    }
  }

  function handleCompanyChange(evt, type) {
    setCompany(OnDataChange(company, evt, type));
  }

  function notifyChange() {
    setChange(date.getTime());
  }

  async function saveCompany() {
    if (!company.name) {
      toast.error(Message.PendingData);
    } else {
      const result = await CompanyController.Insert(company);
      window.location = `#/reclamar/?empresa=${result}`;
      window.location.reload();
    }
  }

  function selectCompany() {
    setCompany({ ...company, newRegistry: false });
  }

  function processStep() {
    switch (step) {
      case 1:
        return (
          <div className="col-md-10">
            {company && company.newRegistry != true ? (
              <div className="block block-transparent">
                <div className="block-header">
                  <div className="block-title font-w700">
                    Encontre a empresa para reclamar:
                  </div>
                </div>
                <div className="block-content row">
                  <div className="col-md-12">
                    <CompanySearch onSelect={(id) => selectedCompany(id)} />
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-lg btn-white btn-block text-dark mb-4 mt-4"
                      onClick={() => didntFind()}
                    >
                      Não encontrou a empresa?
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="block block-transparent">
                <div className="block-header">
                  <div className="block-title font-w700">
                    Cadastrar empresa:
                  </div>
                </div>
                <div className="block-content row">
                  <div className="col-md-12">
                    <Field
                      title={"Nome da empresa"}
                      name="name"
                      value={company && company.name}
                      onChange={(evt) => handleCompanyChange(evt)}
                      type={FieldTypeObj.Text}
                    />
                    <Field
                      title={"Email"}
                      name="email"
                      value={company && company.email}
                      onChange={(evt) => handleCompanyChange(evt)}
                      type={FieldTypeObj.Text}
                    />
                    <Field
                      title={"Telefone"}
                      name="phone"
                      value={company && company.phone}
                      onChange={(evt) => handleCompanyChange(evt)}
                      type={FieldTypeObj.Mask}
                      mask={"(99) 99999-9999"}
                    />
                    <Field
                      title={"CNPJ"}
                      name="taxId"
                      value={company && company.taxId}
                      onChange={(evt) => handleCompanyChange(evt)}
                      type={FieldTypeObj.Mask}
                      mask={"99.999.999/9999-99"}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-lg btn-warning btn-block text-dark mb-4 mt-4"
                      onClick={() => saveCompany()}
                    >
                      Salvar empresa
                    </button>
                    <button
                      className="btn btn-lg btn-white btn-block text-dark mb-4 mt-4"
                      onClick={() => selectCompany()}
                    >
                      Procurar empresa
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      case 2:
        return (
          <div className="col-md-10">
            <div className="block block-transparent">
              <div className="block-header">
                <div className="block-title font-w700">
                  Vamos começar. Conte-nos a sua história:
                </div>
              </div>
              <div className="block-content">
                <Field
                  name={"title"}
                  value={data && data.title}
                  onChange={(evt) => handleChange(evt)}
                  type={FieldTypeObj.Text}
                  title={"Título da reclamação"}
                  placeholder={"Escreva o título da sua reclamação"}
                />

                <Field
                  name={"description"}
                  value={data && data.description}
                  onChange={(evt) => handleChange(evt)}
                  type={FieldTypeObj.TextArea}
                  title={"Conte a sua história"}
                  placeholder={"Escreva o que aconteceu em detalhes"}
                  hint={
                    "Para dar maior ênfase à sua reclamação, sempre que possível, insira nº de protocolos, nº de notas fiscais, data da ocorrência, CPF ou qualquer outro dado que facilite à empresa reclamada, resolver o seu problema."
                  }
                />
              </div>
            </div>
            {/* <div className="block block-transparent">
              <div className="block-header">
                <div className="block-title font-w700">Anexos:</div>
              </div>
              <div className="block-content">
                <div className="form-group">
                  <div className="ml-2 mr-2 pb-3 border border-rounded bg-white row cursor py-2 row">
                    <span className="col-6 pt-3">
                      <span>
                        Adicione prints e arquivos a sua reclamação (Opcional)
                      </span>
                    </span>
                    <span className="col-6 text-right">
                      <UploadButton
                        title={"Selecionar arquivos"}
                        upload={(files) => uploadFiles(files)}
                        accept={"image/gif, image/jpeg, image/png"}
                      />
                    </span>
                    {change &&
                      data &&
                      data.images &&
                      data.images.map((item, index) => (
                        <div className="col-12 block block-bordered block-fx-pop mt-3">
                          <div className="block-header">
                            <div
                              className="block-title"
                              onClick={() => window.open(item.url, "_blank")}
                            >
                              <img
                                class="img-avatar img-avatar48 mr-3"
                                src={item.url}
                              />{" "}
                              {item.name}
                            </div>
                            <div className="block-tools">
                              <button
                                className="btn btn-dual text-danger"
                                onClick={() => deleteImage(item, index)}
                              >
                                <i className="si si-close" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div> */}

            <div className="block block-transparent">
              <div className="block-header">
                <div className="block-title font-w700">
                  Escreva aqui seus dados para que a empresa possa entrar em
                  contato com você:
                </div>
              </div>
              <div className="block-content row">
                <div className="col-md-6">
                  <Field
                    name={"userName"}
                    value={data && data.userName}
                    onChange={(evt) => handleChange(evt)}
                    type={FieldTypeObj.Text}
                    title={"Nome*"}
                    placeholder={""}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name={"email"}
                    value={data && data.email}
                    onChange={(evt) => handleChange(evt)}
                    type={FieldTypeObj.Text}
                    title={"E-mail*"}
                    placeholder={""}
                  />
                </div>
                <div className="col-md-12">
                  <Field
                    name={"phone"}
                    value={data && data.phone}
                    onChange={(evt) =>
                      handleChange({
                        target: {
                          name: evt.target.name,
                          value: evt.target.value.replace(/[^\d]+/g, ""),
                        },
                      })
                    }
                    type={FieldTypeObj.Mask}
                    mask={"(99) 99999-9999"}
                    title={"Celular*"}
                    placeholder={"(00) 0000-00000"}
                  />
                </div>
                {selectedServices && selectedServices.length > 0 ? (
                  <div className="col-md-12">
                    <Field
                      name={"document"}
                      value={data && data.document}
                      onChange={(evt) =>
                        handleChange({
                          target: {
                            name: evt.target.name,
                            value: evt.target.value.replace(/[^\d]+/g, ""),
                          },
                        })
                      }
                      type={FieldTypeObj.Mask}
                      mask={"999.999.999-99"}
                      title={"CPF*"}
                      placeholder={"000.000.000-00"}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-6">
                  <Field
                    name={"neighborhood"}
                    value={data && data.neighborhood}
                    onChange={(evt) => handleChange(evt)}
                    type={FieldTypeObj.Text}
                    title={"Bairro*"}
                    placeholder={""}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name={"city"}
                    value={data && data.city}
                    onChange={(evt) => handleChange(evt)}
                    type={FieldTypeObj.Text}
                    title={"Cidade*"}
                    placeholder={""}
                  />
                </div>
              </div>
            </div>

            <button
              className="btn btn-lg btn-warning btn-block text-dark mb-4 mt-4"
              onClick={() => validateFieldsForSubmission()}
            >
              Publicar reclamação
            </button>

            <button
              className="btn btn-lg btn-dual btn-block text-dark mb-4 mt-4"
              onClick={() => setStep(step - 1) | window.scrollTo(0, 0)}
            >
              Escolher outra empresa
            </button>
          </div>
        );
      case 3:
        return (
          <div className="col-md-10">
            <div className="block block-transparent">
              <div className="block-content text-center">
                <h3 className="text-muted">
                  Sua reclamação foi publicada! <br />
                  Em breve teremos um retorno
                </h3>
                <i className="fa fa-check-circle fa-5x text-success py-3 mb-3" />
              </div>
            </div>
            
            <div className="block block-transparent">
              <div className="block-header">
                <div className="block-title font-w700">
                  Deseja acrescentar algum serviço na sua reclamação?
                </div>
              </div>
              <div className="block-content">
                {services.map((service) => (
                  <div className="block block-rounded block-bordered border-warning p-2">
                    <div
                      key={service.id}
                      className="custom-control custom-switch custom-control-warning mb-0"
                    >
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`service-${service.id}`}
                        name={`service-${service.id}`}
                        checked={selectedServices.includes(service.id)}
                        onChange={() => handleServiceSelection(service.id)}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`service-${service.id}`}
                      >
                        {service.name} - {MoneyMask(service.price)}
                      </label>
                      <p className="text-muted ml-5 pb-0 mb-0">
                        {service.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button
              className="btn btn-lg btn-warning btn-block text-dark mb-4 mt-4"
              onClick={() => {
                if (selectedServices.length > 0) {
                  openPaymentModal();
                } else {
                  goToComplains();
                }
              }}
            >
            {selectedServices.length > 0 ? "Continuar" : "Ver minhas reclamações"}
              {/* Continuar */}
            </button>
            <button
              className="btn btn-lg btn-dual btn-block text-dark mb-4 mt-4"
              onClick={() => setStep(step - 1) | window.scrollTo(0, 0)}
            >
              Voltar
            </button>
          </div>
        );
      case 4:
        return (
          <div className="col-md-10">
            <div className="block block-transparent">
              <div className="block-content text-center">
                <h3 className="text-muted">
                  Sua reclamação foi publicada! <br />
                  Em breve teremos um retorno
                </h3>
                <i className="fa fa-check-circle fa-5x text-success py-3 mb-3" />
              </div>
            </div>
            <button
              className="btn btn-lg btn-warning btn-block text-dark mb-4 mt-4"
              onClick={() => goToComplains()}
            >
              Ver minhas reclamações
            </button>
            <button
              className="btn btn-lg btn-white btn-block text-dark mb-4 mt-4"
              onClick={() => goHome()}
            >
              Ir para a Home
            </button>
          </div>
        );
      default:
        break;
    }
  }

  return (
    <>
      {company && company.id ? (
        <div className="block-content border block-bordered block-content-sm block-content-full bg-white">
          <div className="media py-3">
            <div className="mr-3 ml-2 overlay-container overlay-right">
              <img
                className="img-avatar img-avatar48"
                src={
                  company.logo
                    ? company.logo
                    : "assets/media/avatars/avatar4.jpg"
                }
                alt=""
              />
            </div>
            <div className="media-body">
              <div className="row">
                <div className="col-sm-7">
                  <a
                    className="font-w600"
                    href={`#/empresa/${company.id}?name=${company.name}`}
                  >
                    {company.name} -{" "}
                    <a
                      type="button"
                      className="btn btn-sm btn-warning text-dark"
                    >
                      Ver reclamações da empresa
                    </a>
                  </a>
                  <div className="font-size-sm text-muted">
                    {company && company.taxId && CnpjMask(company.taxId)}
                  </div>
                </div>
                <div className="col-sm-5 d-sm-flex align-items-sm-center">
                  <div className="font-size-sm font-italic text-muted text-sm-right w-100 mt-2 mt-sm-0"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row no-gutters justify-content-center mt-5 mb-10 ml-3 mr-3">
        {step && processStep()}
      </div>

      <Modal show={showPaymentModal} onHide={closePaymentModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Pagamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading === true ? (
            <div className="text-center py-3">
              <i className={"fa fa-circle-notch fa-spin"} />
            </div>
          ) : (
            ""
          )}
          <Tabs defaultActiveKey="creditCard" id="payment-tabs">
            <Tab eventKey="creditCard" title="Cartão de Crédito">
              <Form onSubmit={handleCardSubmit}>
                <Form.Group controlId="cardNumber">
                  <Form.Label>Número do Cartão</Form.Label>
                  <Form.Control
                    type="text"
                    name="number"
                    placeholder="1234 5678 9012 3456"
                    value={cardData.data.number}
                    onChange={handleCardDataChange}
                    maxLength={16} // Add max length for card number`
                  />
                </Form.Group>
                <Form.Group controlId="cardHolderName">
                  <Form.Label>Nome no Cartão</Form.Label>
                  <Form.Control
                    type="text"
                    name="holderName"
                    placeholder="João da Silva"
                    value={cardData.data.holderName}
                    onChange={handleCardDataChange}
                    maxLength={50} // Add max length for holder name
                  />
                </Form.Group>
                <Form.Row>
                  <Form.Group controlId="cardExpMonth" className="col-md-6">
                    <Form.Label>Mês de Validade</Form.Label>
                    <Form.Control
                      type="text"
                      name="expMonth"
                      placeholder="MM"
                      value={cardData.data.expMonth}
                      onChange={handleCardDataChange}
                      maxLength={2} // Add max length for expiration month
                    />
                  </Form.Group>
                  <Form.Group controlId="cardExpYear" className="col-md-6">
                    <Form.Label>Ano de Validade</Form.Label>
                    <Form.Control
                      type="text"
                      name="expYear"
                      placeholder="AA"
                      value={cardData.data.expYear}
                      onChange={handleCardDataChange}
                      maxLength={2} // Add max length for expiration year
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Group controlId="cardCvv">
                  <Form.Label>CVV</Form.Label>
                  <Form.Control
                    type="text"
                    name="cvv"
                    placeholder="123"
                    value={cardData.data.cvv}
                    onChange={handleCardDataChange}
                    maxLength={3} // Add max length for CVV
                  />
                </Form.Group>

                {/* Campos de Endereço de Cobrança */}
                <h5 className="mt-4">Endereço de Cobrança</h5>
                <Form.Group controlId="billingAddressZipCode">
                  <Form.Label>CEP</Form.Label>
                  <Form.Control
                    type="text"
                    name="billingAddress.zipCode"
                    placeholder="00000-000"
                    value={cardData.data.billingAddress.zipCode}
                    onChange={handleCardDataChange}
                  />
                </Form.Group>
                <Form.Group controlId="billingAddressStreet">
                  <Form.Label>Rua</Form.Label>
                  <Form.Control
                    type="text"
                    name="billingAddress.street"
                    placeholder="Rua Exemplo"
                    value={cardData.data.billingAddress.street}
                    onChange={handleCardDataChange}
                  />
                </Form.Group>
                <Form.Group controlId="billingAddressNumber">
                  <Form.Label>Número</Form.Label>
                  <Form.Control
                    type="text"
                    name="billingAddress.number"
                    placeholder="123"
                    value={cardData.data.billingAddress.number}
                    onChange={handleCardDataChange}
                  />
                </Form.Group>
                <Form.Group controlId="billingAddressNeighborhood">
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    type="text"
                    name="billingAddress.neighborhood"
                    placeholder="Bairro Exemplo"
                    value={cardData.data.billingAddress.neighborhood}
                    onChange={handleCardDataChange}
                  />
                </Form.Group>
                <Form.Row>
                  <Form.Group
                    controlId="billingAddressCity"
                    className="col-md-12"
                  >
                    <Form.Label>Cidade</Form.Label>
                    <Form.Control
                      type="text"
                      name="billingAddress.city"
                      placeholder="São Paulo"
                      value={cardData.data.billingAddress.city}
                      onChange={handleCardDataChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    controlId="billingAddressState"
                    className="col-md-6"
                  >
                    <Form.Label>Estado</Form.Label>
                    <Form.Control
                      type="select"
                      as={"select"}
                      name="billingAddress.state"
                      maxLength={2}
                      placeholder="SP"
                      value={cardData.data.billingAddress.state}
                      onChange={handleCardDataChange}
                    >
                      {States.map((state) => (
                        <option key={state.shortName} value={state.shortName}>
                          ({state.shortName}) {state.longName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group
                    controlId="billingAddressCountry"
                    className="col-md-6"
                  >
                    <Form.Label>País</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={2}
                      name="billingAddress.country"
                      placeholder="BR"
                      value={cardData.data.billingAddress.country}
                      onChange={handleCardDataChange}
                    />
                  </Form.Group>
                </Form.Row>

                <Button variant="primary" type="submit" block>
                  Pagar com Cartão
                </Button>
              </Form>
            </Tab>
            <Tab eventKey="pix" title="Pix">
              <div className="text-center">
                <p>Escaneie o QR Code abaixo para realizar o pagamento:</p>
                {pixData?.qrCodeUrl && (
                  <img
                    src={pixData.qrCodeUrl}
                    alt="QR Code for Pix Payment"
                    className="img-fluid"
                  />
                )}
                {pixData.qrCode && <p>Ou use a chave Pix: {pixData.qrCode}</p>}
                {!pixData.qrCode && (
                  <Button
                    variant="success"
                    onClick={handlePixSubmit}
                    block
                    className="mt-3"
                  >
                    Gerar código Pix para pagamento
                  </Button>
                )}
                {pixData.qrCode && (
                  <Button
                    variant="success"
                    block
                    className="mt-3"
                    onClick={handleCopyPixCode}
                  >
                    Copiar Chave Pix
                  </Button>
                )}
                {pixData.qrCode && (
                  <Button
                    variant="success"
                    onClick={handleOrderPaymentStatus}
                    block
                    className="mt-3"
                  >
                    Confirmar Pagamento via Pix
                  </Button>
                )}
                {data?.orderStatus && <div>Status: {data?.orderStatus}</div>}
                {pixData.expiresAt && (
                  <div>PIX Expira em: {DateTranslate(pixData.expiresAt)}</div>
                )}
                {pixData.hasError && <div>Erro: {pixData.errorMessage}</div>}
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closePaymentModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Loading loading={loading} />
      <ToastContainer className="toastr" />
      <RegisterOrLoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        endLoginOrRegister={() => submitComplain()}
      />
    </>
  );
}
